var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1131.045,
    height: 699.93,
    viewBox: "0 0 1131.045 699.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.493,
    gradientTransform: "translate(-0.015) scale(1.031 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aee7f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cf"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.5,
    r: 0.581,
    gradientTransform: "translate(0.117) scale(0.766 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.5,
    cy: 0.5,
    r: 0.586,
    gradientTransform: "translate(0.122) scale(0.756 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.5,
    cy: 0.5,
    r: 0.506,
    gradientTransform: "translate(0.012) scale(0.976 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.5,
    cy: 0.5,
    r: 0.467,
    gradientTransform: "translate(-0.08) scale(1.159 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 0.5,
    cy: 0.5,
    r: 0.422,
    gradientTransform: "translate(-0.268) scale(1.536 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 0.5,
    cy: 0.5,
    r: 0.41,
    gradientTransform: "translate(-0.353) scale(1.707 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 0.5,
    cy: 0.5,
    r: 0.652,
    gradientTransform: "translate(0.178) scale(0.645 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 0.5,
    cy: 0.5,
    r: 0.771,
    gradientTransform: "translate(0.242) scale(0.516 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 0.5,
    cy: 0.5,
    r: 0.505,
    gradientTransform: "translate(0.009) scale(0.983 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 0.5,
    cy: 0.5,
    r: 0.387,
    gradientTransform: "translate(-0.619) scale(2.237 1)",
    xlinkHref: "#radial-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Map",
    transform: "translate(-0.002 -0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "States",
    transform: "translate(0.52 0.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OK",
    transform: "translate(425.373 390.171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OK-2",
    "data-name": "OK"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2543",
    "data-name": "Path 2543",
    d: "M607.322,394.838l-160.2-3.406-21.127-1.282-.851,13.223,65.065,3.847-1.7,52.693,2.344.421,1.282,1.072,3.2,4.047,1.493.641,4.488-.421,1.493-1.282,2.555,1.282.641,1.272-.21,1.282,1.282,1.923.641.421,5.971,1.072,2.134,1.062h1.272l.431-.421,1.7-.431,1.493,2.134,2.354,1.072,1.493-1.713,5.76.862v.852l2.555,2.134.852.421v2.775l4.268.852.862-2.775,1.7-.641,5.329,4.057h.852l2.354-1.713H551l.22,1.072-.431,2.344.852,1.713,1.493-1.072-.21-1.493,1.7-2.344,2.134-1.282.851.22.22,1.7,2.555.852h1.072l.852-1.282,1.7.22.431.421v.641l2.134,1.072L570,485.3l3.626-2.775,1.272-.641,4.909-.431,4.057-1.493,1.493-.21h1.923l4.9.641,3.206-1.062.641-.641,10.879,5.75,1.913.641.861,1.072,1.062.21.641-47.995-3.837-29.873Z",
    transform: "translate(-425.14 -390.15)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "VA",
    transform: "translate(846.408 293.259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VA-2",
    "data-name": "VA"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2544",
    "data-name": "Path 2544",
    d: "M1008.058,362.122l-54.4,10.459-57.171,9.387-1.062-.431-2.344.641-6.011.641.431-1.072-6.011,1.072v.641l-36.064,4.478,1.493-1.493,7.674-3.626.851-1.923,4.268-3.005.22-1.923.641-1.062,2.134-1.282.21-2.344,2.134-1.923,11.09-9.6.641-2.134.852.641-.852,2.134,3.416,3.2,4.688,1.713,2.134.21,2.565-2.134.21-1.493,1.7-.852,1.713,1.493,1.062.641,1.713-.431,5.329-2.134.851-3.416h.641l1.282,1.072,4.268-3.847,1.493.862,3.626-4.7-.851-1.913.21-3.206,3.626-6.822,4.688-17.711.862-.21,2.555,1.7.431,1.072,1.272,1.493,2.775-.641,1.923-3.2,1.7-6.622,1.493-2.555,2.565,1.062,1.7-3.837,1.713-.641,1.493-2.134,1.272-3.626,1.072-.852.21-.851-.852-.852.431-5.339.421-.852.852-.641,9.817,6.191,1.493.421.431-.421,1.062-5.339h1.713l1.7.641,2.134.641-1.192,2.194,2.344,2.565h4.007l1.923,1.913,2.555,1.072,1.923,2.344-.431,1.282-2.555,4.688-1.713,4.268.431,3.005,3.2.22,2.775-1.713,2.134,2.565,1.282.641,1.062.21,1.713,1.493.851.21,1.493-.851.851.22,4.909,2.555,3.416,1.062,1.913,2.134-.21,1.072-1.282,1.062.641,3.416-.641.641-1.062.641v.421l3.837,1.713,1.282,2.775-.21,1.062-.641.852-3.005-.641-.431,1.282,1.062,1.282.641-.21v1.062l-1.7.641h-.852l-.22.641,1.072.852,2.555.22,2.354.852.641,1.272-2.5,2.575h-1.282l-3.2-1.072v1.282l2.134,1.072,1.913,1.7,2.354-.851,2.344-1.713h5.55l.21.431,2.555,7.463-1.9,1.7h-.431ZM1007,322.872l.641.21.21,2.344-.21,1.282-1.713,1.923-.852,1.7-.631,4.268.631,3.837V342.5l1.072,3.005.641-4.007,1.272-4.057,2.565-6.011,1.062-2.565.641-2.344-.21-3.416.21-1.272,3.005-2.354.431-1.062-7.012,2.344Z",
    transform: "translate(-845.43 -293.41)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "NM",
    transform: "translate(274.766 375.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NM-2",
    "data-name": "NM"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2545",
    "data-name": "Path 2545",
    d: "M296.559,375.67,274.8,529.482v.21l19.845,2.134,1.483-11.941,37.546,4.688-.421-.431-.852-2.134.852-1.7-.21-.421-.641-.862.421-.421,81.7,7.674L424.345,403.4h1.062l.851-13.223Z",
    transform: "translate(-274.8 -375.67)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "MD",
    transform: "translate(919.868 275.187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MD-2",
    "data-name": "MD"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2546",
    "data-name": "Path 2546",
    d: "M994.063,275.37l-18.132,3.2-57.171,11.1,3.206,14.075,1.062-1.913,1.282-.641,4.268-4.909,1.913-.431,1.5-2.555,1.493-.641,1.272-2.775,1.072,1.282,2.555.641,2.775-.852.641-1.923,6.822-2.344,1.5.852h1.7l1.7-.641.862,2.344,1.062.22,2.344,4.9h1.713l1.7.641,2.134.641-1.282,2.134,2.344,2.565h4.057l1.923,1.913,2.555,1.072,1.923,2.344-.431,1.282-2.555,4.688-1.713,4.268.431,2.985,3.2.22,2.775-1.713,2.134,2.565,1.282.641v-.851l2.775-.641,3.2.21,4.478,1.493,2.134,1.072.851-.22.22-.852-1.072-1.062-1.913-3.206-1.923-.431-.21-.421.21-.852h.641l.852-1.072-2.344-.852-1.713-2.775-1.493-4.688-.421-1.923-.431-2.775.852-4.688-.21-1.493-.851-.862-.22-1.272.431-1.072.641-1.062.641-1.713,3.626-2.765.641-.862,1.062-3.626,2.354.22.852,1.272-1.713,3-1.272,2.134-1.282,1.7-1.072,2.344,1.072,2.344,1.7.641,1.072,5.119-.22.862-2.775,1.7.431,1.062,2.344.862.641,1.062-.641,2.344.641,1.282-.21,1.282,1.282,2.985,2.985,2.134h1.493l1.062-.852h1.713l.852.421-.431,1.713,1.713,2.985v1.062l1.062,1.713,2.565-.22.421.431,1.493-2.134,7.042-2.344.21-1.072.431-1.7,1.7-8.956-.21-.862-13.654,3Z",
    transform: "translate(-918.76 -275.37)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "KS",
    transform: "translate(447.352 308.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KS-2",
    "data-name": "KS"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2547",
    "data-name": "Path 2547",
    d: "M451.768,309.02l139.1,3.2,8.956,6.832-2.775,3.406-.641,3.416,1.493,1.7,2.354,1.072,1.272,4.688,2.134,1.5,2.134.421.852.641.641,59.085-160.2-3.406Z",
    transform: "translate(-447.08 -309.02)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "NE",
    transform: "translate(412.791 223.566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NE-2",
    "data-name": "NE"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2548",
    "data-name": "Path 2548",
    d: "M412.58,278.447l4.688-54.607,110.075,5.76,3,4.268h3.626l2.775-.641,2.134,1.493,1.7,3.626,2.775.641,2.985-.641,2.775-2.134h3.626l2.134.641,8.745,5.76,4.268,2.985v2.775l2.985,1.7V252l-1.282,3.837,2.134,1.923L573,262.238l2.344,2.134-.851,2.134.851,2.344,2.775,2.134.852,2.134-.852,2.344-.641,4.268,2.775,1.493.852,2.134-1.493,2.134.641,2.134,1.493,2.134-.641,2.134.641,2.985.851,1.282,1.493,2.344,2.134,2.134.641,3.626,2.985,3.626,1.282.852-.641,2.775.431.852-139.1-3.2,1.7-27.308-40.952-3.416Z",
    transform: "translate(-412.58 -223.84)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SD",
    transform: "translate(417.479 143.133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SD-2",
    "data-name": "SD"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2549",
    "data-name": "Path 2549",
    d: "M417.26,223.982l4.488-53.976,2.344-26.457,141.861,6.191.21,2.344-1.272,2.775-3.416,3.626.21,2.344,6.832,6.622.21,49.7-1.282-.21-1.7.21.641,1.713.852,1.493-1.072,2.775,1.493,1.483.861,4.057-1.5,1.282.431,2.344-2.134,4.909,2.134,5.119.431,2.775v.641l-4.268-2.985L554.864,237l-2.134-.641H549.1l-2.775,2.134-2.985.641-2.775-.641-1.7-3.626-2.134-1.493-2.775.641H530.33l-3-4.268Z",
    transform: "translate(-417.26 -143.55)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ND",
    transform: "translate(424.311 60.577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ND-2",
    "data-name": "ND"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2550",
    "data-name": "Path 2550",
    d: "M424.08,143.7,430.9,61.14,467.6,63.7l26.026,1.913,61.228,1.713.21,2.134,1.923,6.4-.641,1.913-.641,4.478.21,7.684,1.7,8.745,2.354,2.565,1.493,7.894.421,13.654.862,2.765v4.909l.21,2.134,3.2,9.6-.421,3.626.21,4.057Z",
    transform: "translate(-424.08 -61.14)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "MT",
    transform: "translate(209.912 29.652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MT-2",
    "data-name": "MT"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2551",
    "data-name": "Path 2551",
    d: "M422.115,170.208,287.5,153.779l-1.913,13.654v.22l-1.923-1.923-.852-3.206-2.775-2.985-2.344,1.923.21,2.134h-5.54l-.862.421-2.344-1.272-5.119-.22-1.062-1.062-1.5.21-1.7,1.713-1.923-.22-4.268-1.7-1.062.852-1.282,2.565-2.765-1.493-1.282-2.985v-1.072l.641-3.626L247.4,154l-1.923-2.565h-2.344l-2.134-3.416,1.282-2.344v-1.7l-2.134-2.985-1.282-3.636v-5.54l.641-3.416-1.072-.852-.631-.641-.862-1.923-.631-.421-.862.421-5.971,4.7-1.062.431-3.847-3.847,1.072-2.134-.21-1.7v-2.344l3.2-2.134.21-2.344-.421-.431.21-4.268,1.493-1.282-.21-1.493,4.268-8.745L232.89,97.89l-4.057-.641-.21-2.134-2.985-.21-1.493-3.416-.641-3.416L220.3,80.819l-4.688-4.478-2.134-2.985-1.282-1.493,1.072-1.282.852-2.775-.852-4.478-3.206-7.042,4.7-26.016,20.266,3.406,54.186,9.176,55.458,9.387,86.613,8.956-6.822,82.556Z",
    transform: "translate(-210.06 -30.27)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "WY",
    transform: "translate(271.14 153.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WY-2",
    "data-name": "WY"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2552",
    "data-name": "Path 2552",
    d: "M412.831,278.571l4.688-54.607,4.488-53.976L287.389,153.56l-1.913,13.654-9.817,67.63h-.21L271.18,261.3l40.1,6.181,101.55,11.09Z",
    transform: "translate(-271.18 -153.56)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CO",
    transform: "translate(296.525 267.083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CO-2",
    "data-name": "CO"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2553",
    "data-name": "Path 2553",
    d: "M296.52,375.862,311.236,267.28l101.55,11.09,40.952,3.416-1.7,27.308-4.688,82.556-21.127-1.282Z",
    transform: "translate(-296.52 -267.28)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "UT",
    transform: "translate(189.225 223.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UT-2",
    "data-name": "UT"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2554",
    "data-name": "Path 2554",
    d: "M296.71,375.939l14.716-108.582-40.1-6.181,4.268-26.457L215.646,224.05,189.41,359.089h0Z",
    transform: "translate(-189.41 -224.05)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ID",
    transform: "translate(156.156 26.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ID-2",
    "data-name": "ID"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2555",
    "data-name": "Path 2555",
    d: "M197.573,26.86l17.281,3.416-4.7,26.016,3.206,7.042.852,4.478-.852,2.775-1.072,1.282,1.282,1.493,2.134,2.985,4.688,4.478,3.206,7.253.641,3.416,1.493,3.416,2.985.21.21,2.134,4.057.641,1.282,1.493L230,108.134l.21,1.493-1.493,1.282-.21,4.268.421.431-.21,2.344-3.2,2.134v2.344l.21,1.7-1.072,2.134,3.847,3.847,1.062-.431,5.971-4.7.862-.421.631.421.862,1.923.631.641,1.072.852-.641,3.416v5.54l1.282,3.636,2.134,2.985v1.7l-1.282,2.344,2.134,3.416h2.344l1.923,2.565.431,1.7-.641,3.626v1.072l1.282,2.985,2.765,1.493,1.282-2.565,1.062-.852,4.268,1.7,1.923.22,1.7-1.713,1.5-.21,1.062,1.062,5.119.22,2.344,1.272.862-.421H278l-.21-2.134,2.344-1.923,2.775,2.985.852,3.206,1.923,1.923v-.22l-9.817,67.63h-.21L215.7,224.4l-59.3-12.372,10.669-48.215,2.765-3.406.22-3.206.641-.431.21-.851.852-1.493-1.282-2.134-3.2-1.493-.641-1.7.852-3.206,4.909-7.463,2.985-1.493,2.134-2.134v-1.923l1.713-1.493,9.377-14.506-.631-3.837-1.923-1.7-1.713-.431-1.913-2.565L182,106l-.21-3.416.852-1.272.431-1.493-1.282-2.134V95.341l.852-1.072Z",
    transform: "translate(-156.4 -26.86)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "WA",
    transform: "translate(53.545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WA-2",
    "data-name": "WA"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2556",
    "data-name": "Path 2556",
    d: "M183.249,99.866l-.431,1.493-.852,1.272.21,3.416L144.21,97.091l-2.775,1.282h-1.923l-1.913-.641-2.565-.22-1.493-.641h-1.923l-2.134.641-2.765-.641h-2.344l-2.785,1.282-2.124.431-4.7-.641-1.282-.852-2.765-1.072-8.745,1.072-1.713-2.344-7.253-2.134-3.416-.431-4.478.431L78.5,92.182,72.954,89.2l-1.062-2.134.421-6.832.431-1.272L72.1,74.691l-4.047-2.985-3-.431-.421-.852-1.713-1.7L59.52,67.228l-.431-.431-3.416-2.134-1.062-.21-.641-.22V63.171l.852-3.2.641-1.5V56.339l.641-.21.421.21.22,1.923-.22,1.072-.21.641.21.852,2.565-2.354-.21-.852V56.339l1.062-1.272-.852-1.713L57.6,52.932l-.21-4.057.641-.421,1.493.421.421-.641,2.775-.641-1.923-1.7v-.431l-.631-.631L58.238,46.1V41.412L58.879,38l-.431-2.555-.21-2.354.641-5.54.431-2.344L56.955,17.73l.22-5.119.852-2.775L58.668,6,72.1,15.386l7.042,3.837,5.55,1.7,3.2,1.923h2.775l1.062.641L92.8,25.2l.421,6.6-.421,1.5L90.665,34.8l-.852,2.985V40.13l.21,1.282-.21,1.282-.641,1.062v1.072l1.282,1.062,2.555-1.282,1.7-5.971,1.072-1.282,1.062-2.775,3.626-3.626.22-1.493-1.5-5.329-2.765-7.463-.21-1.282.852-.431,1.493.431,1.7-3.416-.21-3.837H97.707l-.22-2.565-.21-4.9,28.581,7.884,27.1,7.253,44.8,11.1L182.818,94.316l-.852,1.072v2.344Z",
    transform: "translate(-53.97 -0.67)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "OR",
    transform: "translate(14.295 66.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OR-2",
    "data-name": "OR"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2557",
    "data-name": "Path 2557",
    d: "M171.157,155.847l-.21.851-.641.431-.22,3.206-2.765,3.406-10.669,48.215L98.418,198.3,17.345,176.113l-1.062-1.272-1.493-5.55,1.272-2.775v-2.344l1.713-4.268-.852-8.535,1.272-1.923,1.713-.852,1.062-1.493,1.072-2.775,1.062-1.062.431-3.847.852-.21,5.119-6.181,2.565-5.76,4.478-8.325L41.457,103.8l3.626-6.4,3.2-9.387,3.837-11.731,1.5-4.047L54.25,68.6V67.531l1.923-.641,2.134.641,1.282-.421L63,68.6l1.713,1.7.421.852,3,.431,4.047,2.985.641,4.268-.431,1.272-.421,6.832,1.062,2.134,5.55,2.985,6.612.431,4.478-.431,3.416.431,7.253,2.134,1.713,2.344L110.79,95.9l2.765,1.072,1.282.852,4.7.641,2.124-.431,2.785-1.282h2.344l2.765.641,2.134-.641h1.923l1.493.641,2.565.22,1.913.641H141.5l2.775-1.282,37.967,8.956.431,2.344,1.913,2.565,1.713.431,1.923,1.7.631,3.837-9.377,14.506-1.713,1.493v1.923l-2.134,2.134-2.985,1.493-4.909,7.463-.852,3.206.641,1.7,3.2,1.493",
    transform: "translate(-14.79 -66.89)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "KY",
    transform: "translate(719.133 322.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KY-2",
    "data-name": "KY"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2558",
    "data-name": "Path 2558",
    d: "M718.38,403.494l31.566-2.555v-2.565l-.852-1.493,3.626-.421,1.493,1.062,89.6-8.315,1.923-1.282,1.493-1.493,7.674-3.626.852-1.923,4.268-2.985.22-1.923.641-1.062,2.134-1.282.21-2.344,2.134-1.923,11.09-9.6.641-2.134H875.6l-1.493-1.072h-.641l-.641-.852-2.134-1.062-1.062.21-.641-.431-2.775-4.258-4.478-5.55-.431-1.7.21-1.713v-2.555l-.631-3.416-.862-.852-2.344-1.7-2.344-.651-2.134-2.975-1.062-1.713-2.565,1.923-.641,1.062-1.493.852-.431.641-3.2.431-3.837-1.493-1.493.21-1.713,2.344-4.478-3.2-4.478.431-3.206-1.282-1.493-3.847-4.267-3.2L816.5,323.5h-1.282l-2.134-1.072h-1.7l-.851,1.923v1.493l1.282,4.7-.862,1.7-2.344.641-2.985,2.344L802,334.382l-1.7,1.282v4.047l-8.535,11.1-1.493,4.9-5.329.22-2.354-2.775-1.493-.21-1.272,1.7-1.713,5.55-1.7,1.493-2.134-1.493-1.493-1.923-3.626,1.282-1.282,4.268-1.282.421-.641-.641-6.391-2.985-5.129,1.923-4.047-.21-.641,1.913.21.851-1.7.641-1.7-.21h0l.421.431-.851,1.272-.431,2.134-.852.641v.851l2.134,2.775-.421.431-6.622,1.913L738,377.047l.421,2.775,1.282,5.54-2.985,1.282-2.565-1.913-2.765-1.282-3.626-.641L725.2,384.09,723.92,389l.431.421.641.431,1.062.852.852,2.555-2.134,6.832-1.272.852-1.072-.641-2.775,1.282Z",
    transform: "translate(-718.38 -322.22)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ME",
    transform: "translate(1050.85 36.474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ME-2",
    "data-name": "ME"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2559",
    "data-name": "Path 2559",
    d: "M1049.51,105.341l15.367,46.082.21.852-.21,1.923.21.851,3.837,2.985.851.22.431,1.493v1.062l2.134,3.626.421-1.062.431-2.565.431-3.416,1.7-3.406,1.072-5.119,2.124-1.923.22-1.072-1.072-.641-1.062-2.985,5.119-4.688.851.641.851,2.134.641.641.641-.852v-2.354l.431-1.282,3.837-.421,1.7-1.7v-1.713l.641-.851h1.923l1.493-.852.641-.852.851-3.416-.431-2.565,2.564-2.775v-1.7h1.062l2.775.431,1.282-.641.852-1.493,1.072-2.565,1.062-.21,1.713-2.985,2.985.21,2.124,2.134,3-5.329,2.555-1.282,4.057-3.626,1.062-1.923.641-.421h1.072l1.913-1.072,1.072-2.344-.431-1.713-1.7-.852-.21.22-1.072-.431.641-1.923.641-.421V91.907l-1.713-3.416-2.124-1.062-1.282.21-.641.852-1.713.431-1.913-.641-1.713-6.832.641-.852-.421-1.272-.641-.862h-1.282l-.641.641-2.985-1.062h-1.7l-.852-.641-1.282-4.057-.221-1.062-9.377-29.873-8.325-5.119-2.134-.21h-2.134l-.641,1.282-.641,1.493h-1.062l-2.985,1.493-4.267,3.416-1.282.421-1.7-2.134.421-2.985-.852-1.282h-1.282l-3.2,1.282-6.832,23.251-.421,3.416,1.282,1.7.21,2.565-.852,1.7-1.072,1.072-.851,2.134,2.344,9.387-1.272,2.985v2.555l-3.416,4.488-.431,1.7,1.282,3.2-.21.431h-1.923l.21,2.344-.641,1.493-1.062-.21-1.493-.641Z",
    transform: "translate(-1049.51 -37.08)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "MI",
    transform: "translate(682.858 101.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2560",
    "data-name": "Path 2560",
    d: "M761.18,255.984l41.814-5.329.21,1.272,26.457-3.406.421-1.282,3.2-6.4,1.282-1.7-.21-4.268,1.062-3.416,3.416-2.775v-3.626l.641-.641v-1.923l1.923-1.7.852,1.923.641.21,1.282-.852.631-.851.431-1.923-.641-3.626.431-4.688-1.282-2.985-.852-6.622L836.9,185.8l-5.971-1.923-2.344,1.493-2.775,2.775L818.772,198.6h-.631l-.641-.431-2.775-1.062-.852-.862L812.8,193.9l.862-4.268,1.272-1.923,3.416-2.134.852-1.913.21-1.493.431-1.923,1.7-.852,1.493-3.416V169.16l-1.062-3.416-1.072-1.923-2.134-2.555-.631-1.282.421-1.7,2.344-.852.431-.641-2.775-4.909-2.344-1.282-7.042-2.775-5.119-.851-1.7-2.134-4.057-.852-3.837-1.282-2.775-1.913-1.7,1.493-2.134.852-2.134,3.837v2.985l.421,1.282H787l.421,1.282-.851.421-1.7.862-1.282.852-1.493,1.913-1.493,2.775.421,2.985.431,2.775-1.7,3.206-2.354,1.272-.421-2.344,1.062-2.765-1.062-3,.421-1.062-.21-.852-1.072.641-1.272,2.124-.431,2.565-.852,1.493h-1.493l-2.565,2.134-.852,1.923-.421,1.493-2.134,2.555-.22,4.268-.21,4.909-.421,2.775-1.713,3.626-1.493,2.134.431,2.344,1.913,5.971-1.062,3.626,1.493,3.206,3.837,8.1,2.775,6.612v5.55l1.282,1.272v.862l-.851.852-.641,5.76-1.072,4.047-1.493,4.057-3.406,7.894-3,2.565Z",
    transform: "translate(-682.03 -101.541)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2561",
    "data-name": "Path 2561",
    d: "M682.17,129.119l3.847-1.272,1.913-1.282,4.057-2.344.852-1.923,1.7-.21,7.263-2.775,5.119-2.775,5.971-6.191,2.134-.421,4.909-5.55,3.406-1.7,5.55-1.062,1.493.421.21.641-2.985,2.134-.852.21-1.282,2.565-4.047,4.478-1.923,1.7-1.062,1.493-.862,3.837.862,2.565.631-1.493,3.416-2.775,2.344.22,1.5-.431,7.463,3.2,5.971,6.4,4.7-.641,2.344.431,1.7.852h1.493l.641-.21,1.7.641v.852l1.072-.852.852-1.713,5.339-3.837,17.06-4.268,4.478-2.555,2.134-.641.852,1.062-1.272,2.344v1.493L785,123.789l1.272.431.862-.641,2.765.21,1.282-.641,5.339-.641L798.867,124l2.344,4.268,1.7,1.713,4.057,1.913,4.478-1.062h1.072l1.062,1.062.22,1.493L812.09,135.1l-2.775.21-1.493-.21-.421-.851h-.862l-2.765,1.493-1.923-.641-1.713-.22-4.688,1.072-2.775-.852-1.062.852.641,2.555-.641.851-1.282-.421-2.775-2.565-7.042-.852-1.493.431-1.7-.852-4.909,3.626h-1.062l-1.923,1.062-.641.852-1.062.431-2.775-.641-2.985.641-.21,2.344-.641,1.282-5.981,5.329-1.062-.421-.641-.852,2.565-3.416v-1.713l-3.416.22-1.282,3.2-1.282,1.282-1.272-1.493-.431-2.985-.641.421-.641,3.847-2.134,3.837-1.282,3.837-1.272,2.354-2.775,4.258v3l-.431,1.062-2.985-1.7-.851-3.206,1.062-1.062.431-1.493-.431-.431-3.406.641-.641-.21,1.062-6.832-.421-2.555-3.416-1.713-2.985-.851.21-.852.431-.641-1.072-1.062-2.775-.862-4.478-.852h-1.282l-.852.852-.852-.852h-2.565l-3.837-3.2h-2.134l-17.922-3.626-1.272-.641-.862-3.2-1.272-1.072-2.775-.431Z",
    transform: "translate(-682.17 -101.61)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "RI",
    transform: "translate(1060.667 192.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RI-2",
    "data-name": "RI"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2562",
    "data-name": "Path 2562",
    d: "M1059.31,195.093l4.478,15.147-.641,1.493-.421.852.21.641.21.641,1.072.21,3.837-2.555,2.344-2.134v-1.713l-.641-1.062v-2.565l1.713-1.7.641.641v4.688l.631,1.072,1.282-.22v-1.913h.851l1.282-1.282,1.923-.21.21-.22-1.493-1.7-.21-.851-.852-.21-.431-.641-1.493-.852v-.862l-3.626-.852-1.062-2.775-1.282-.421-.851-2.565Z",
    transform: "translate(-1059.31 -193.17)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "WV",
    transform: "translate(861.635 269.216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WV-2",
    "data-name": "WV"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2563",
    "data-name": "Path 2563",
    d: "M893.689,269.62l-.631-.21-1.5,1.282,1.072,2.765-2.985,2.565,4.047,1.923-1.493,9.807-.852,2.344v2.354l.431,1.272.21,3.206-2.344,2.134-1.072.431-4.047,4.688v1.062l-2.565.641-1.7-.421-1.713,1.913-.21,1.072-1.913,1.7-2.134,4.7.852,3.406-2.565,2.775-1.7-3.2h-1.713l-2.134,6.4.431,3.2-.431,2.775-1.493,1.282-2.134,3.626-2.765.21.631,3.416V341.3l-.21,1.713.431,1.7,4.478,5.55,2.775,4.258.641.431,1.062-.21,2.134,1.062.641.852h.641l1.493,1.072h1.493l.852.641-.852,2.134,3.416,3.2,4.688,1.713,2.134.21,2.565-2.134.21-1.493,1.7-.851,1.713,1.493,1.062.641,1.713-.431,5.329-2.134.852-3.416h.641l1.282,1.072,4.268-3.847,1.493.862,3.626-4.7-.851-1.913.21-3.206,3.626-6.822,4.7-17.711.852-.21,2.555,1.7.431,1.072,1.282,1.493,2.765-.641,1.923-3.206,1.7-6.612,1.493-2.555,2.565,1.062,1.7-3.837,1.713-.641,1.493-2.134,1.272-3.626,1.072-.852.21-.852-.852-.852.431-5.339.421-.852.852-.641,9.817,6.191,1.493.421.431-.421,1.062-5.339h0l-2.344-4.9-1.062-.22-.862-2.344-1.7.641h-1.7l-1.5-.852-6.822,2.344-.641,1.923-2.775.852-2.555-.641-1.072-1.282-1.272,2.775-1.493.641-1.5,2.555-1.913.431-4.268,4.909-1.282.641-1.062,1.913-3.206-14.075-21.117,4.047Z",
    transform: "translate(-860.63 -269.41)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "OH",
    transform: "translate(804.033 233.593)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OH-2",
    "data-name": "OH"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2564",
    "data-name": "Path 2564",
    d: "M803.13,251.762l8.1,70.825h1.7l2.134,1.072h1.282l2.344-1.282,4.267,3.2,1.493,3.847,3.206,1.282,4.478-.431,4.478,3.2,1.713-2.344,1.493-.21,3.837,1.493,3.2-.431.431-.641,1.493-.852.641-1.062,2.565-1.923,1.062,1.713,2.134,2.975,2.344.651,2.344,1.7.862.852,2.765-.21,2.134-3.626,1.493-1.282.431-2.775-.431-3.2,2.134-6.4h1.713l1.7,3.2,2.565-2.775-.851-3.406,2.134-4.7,1.913-1.7.21-1.072,1.713-1.913,1.7.421,2.565-.641v-1.062l4.047-4.688,1.072-.431,2.344-2.134-.21-3.206-.431-1.272V290.16l.852-2.344,1.493-9.807-4.047-1.923,2.985-2.565-1.072-2.765,1.5-1.282.631.21L887.4,233.85l-10.248,5.119-4.478,2.765-1.7,1.5-5.98,6.391-1.7,1.072-1.7-.21h-3.416l-1.923.421-4.9,4.268-1.923-.421-3.837-1.282-1.072.641-1.493-.431,1.072-1.7-.862-.22-2.985-.421-6.391-2.134-1.282-.431-2.985.641v-1.062Z",
    transform: "translate(-803.13 -233.85)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "IN",
    transform: "translate(747.072 250.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IN-2",
    "data-name": "IN"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2565",
    "data-name": "Path 2565",
    d: "M748.4,257.492l5.339,64.644-.851,1.062.421,2.344-.852,3.416,2.555,4.909.862,5.971-2.985,5.339-.22,1.7-1.913,4.268-3.416,3.2V358.4l-1.072,5.119v1.072l.22,1.062h0l1.7.21,1.7-.641-.21-.852.641-1.913,4.047.21,5.129-1.923,6.391,2.985.641.641,1.282-.421,1.282-4.268,3.626-1.282,1.493,1.923,2.134,1.493,1.7-1.493,1.713-5.55,1.272-1.7,1.493.21,2.354,2.775,5.329-.22,1.493-4.9,8.535-11.1v-4.047l1.7-1.282,3.626.852,2.985-2.344,2.344-.641.862-1.7-1.282-4.7v-1.493l.851-1.923-8.1-70.825-.21-1.272-41.814,5.329-1.282,1.072-3.2,1.272-1.713.862-3.837.631Z",
    transform: "translate(-746.27 -250.46)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "IL",
    transform: "translate(670.487 236.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IL-2",
    "data-name": "IL"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2566",
    "data-name": "Path 2566",
    d: "M740.645,236.83l-56.32,3.837.852,1.493,4.057,2.775.431,2.565,4.047,2.344,1.282,4.688-.21,2.354L693.5,259.65l-1.493,1.5V263.5l-3.626,3.837-3.206,1.062-1.062,1.072-4.057.21-2.124,1.282-1.282,2.775.21,2.344,2.565,2.555.631,1.713-.631,4.047-3,6.622-3.2,2.134-1.062,2.134.21,2.134-1.493,2.344v1.062l-1.072,2.985.431,5.129,1.493,4.478.431,1.913,6.181,7.253,6.191,4.909,1.7,1.713,3.626,9.807,1.062.852,1.923-1.913,1.7-.862,5.129,2.565.852,1.7-1.072,3.416.431,3.837-3.837,4.488-.641,1.7,1.272,3.2,3.636,3.416,5.97,3.837,2.985,1.072,6.181,5.329,1.072,4.7,1.923,2.344v1.062l-1.713,1.713v1.062L721.021,390l.852-.431.22-1.062h1.493l.421.641,1.282-4.909,2.565-1.282,3.626.641,2.765,1.282,2.565,1.913,2.985-1.282-1.282-5.54-.421-2.775L740,376.127l6.622-1.913.421-.431-2.134-2.775v-.851l.852-.641.431-2.134.851-1.272-.421-.431-.22-1.062v-1.072l1.072-5.119v-4.057l3.416-3.2,1.913-4.268.22-1.7,2.985-5.339-.862-5.971-2.555-4.909.852-3.416-.421-2.344.851-1.062-5.339-64.644-1.062-.631-.852-1.713-1.282-5.971-.852-1.7-1.923-1.713-1.923-4.057Z",
    transform: "translate(-669.82 -236.83)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "NC",
    transform: "translate(830.059 362.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NC-2",
    "data-name": "NC"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2567",
    "data-name": "Path 2567",
    d: "M829.11,434.789l.641-6.4h1.923l.852-.21,1.7-1.713.21-1.7-.21-1.072.852-1.493,1.493-2.134,4.478-1.913,5.129-1.282,5.119-4.478,2.134-.852,2.985-3,.851-2.555.421-.21,1.282.21.852-1.282.431-.641,1.7-1.7.641.21,1.493.852,1.713-.852.21-.852,2.775-2.134,1.923-.851,3.406-.21,3.626-6.191,2.985-1.7.22-1.7.421-1.713-.21-2.134.431-1.7v-.641l5.971-1.072-.431,1.072,5.981-.641,2.344-.641,1.062.431,57.171-9.387,54.4-10.458.862,1.072.421.851,1.493.852,1.072.431.852,1.272.852.862,1.072,2.555-.431.851.21.22h-.852l-.21-.862-1.713.431h-1.062l-1.072-.431-.852.22.641,1.062-.21.641-5.119,2.344-1.072,1.072-1.913,1.923-3.206.421-.641,2.134v.641l.641.21,1.072-.21,3.416-1.713,3.406-.851,1.923-1.282,3.2.22.431.431-.431,1.913.431.851.852.641,1.282-.421.421-1.072,1.923-2.344h1.7l1.072,2.555.431,4.268.421,1.282v.851l-2.775,2.134-.641,1.713-.421,1.062-2.134,1.7-1.493.641-1.713,1.072-3.626-.21-1.272-.431-.431.431h-.421l-.651-1.713v-.852l-.631-.641-.852-.21-.641.641.641,3.2-.641,1.072-.431-.431,1.072,1.493,1.483.21,1.5,1.713-1.072,1.913.641,1.072-4.057,5.119-1.272.21-2.354-.852h-1.7l-.21.852,1.493,1.072,4.478-.22,2.775-.851,4.047-1.913.431-1.5,1.062.431,1.5,1.282-1.5,3.406-3.2,3.626-3.837.641-1.493.862-4.478.631-3.626,6.191-1.713.21v.851l.21.22-4.258,2.775-2.354,2.985-2.344,5.329-1.282,6.4-1.062,1.7-2.134.852-8.966,1.713-.852.851L938.975,424.12l-24.744,3.206-.641-3.416-4.268-3.416-2.134,1.062-.851-1.062.421-.852-.21-.852-28.8,3.406h-.851l-.641.862-5.76,2.555-.21,1.282h-1.923l-6.4,3.2Z",
    transform: "translate(-829.11 -362.04)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TN",
    transform: "translate(704.837 383.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TN-2",
    "data-name": "TN"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2568",
    "data-name": "Path 2568",
    d: "M881.815,383.34l-36.054,4.478-1.923,1.282-89.6,8.315-1.493-1.062-3.626.421.852,1.493v2.565l-31.566,2.555-1.713,3.847-1.062,4.688.421,1.493-1.062,4.057-.852,1.282.421,1.272-.851,2.354-2.775,2.985-1.062,5.54-2.775,3.626.421,3.847-.21,4.688-.852.431-2.344,2.134,45.861-3.206,57.171-5.119,22.189-2.555.641-6.4H831.9l.852-.21,1.7-1.713.21-1.7-.21-1.072.852-1.493,1.493-2.134,4.478-1.913,5.129-1.282,5.119-4.478,2.134-.852,2.985-3,.852-2.555.421-.21,1.282.21.852-1.282.431-.641,1.7-1.7.641.21,1.493.852,1.713-.852.21-.852,2.775-2.134,1.923-.851,3.406-.21,3.626-6.191,2.985-1.7.22-1.7.421-1.713-.21-2.134Z",
    transform: "translate(-704.11 -383.34)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SC",
    transform: "translate(858.219 418.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SC-2",
    "data-name": "SC"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2569",
    "data-name": "Path 2569",
    d: "M923.778,502.308h-1.072l-3.2-.21-.852-.641-.852-1.282-1.282-5.54-2.775-3.847-3.416-1.272-1.7-5.76-2.134-2.565-1.062-2.985-1.923-.852-3.837-1.493-2.354-2.985-2.555-1.713-.21-1.493-1.282-2.775-.852-.852-3.626-1.282-7.042-6.612-3.206-1.062-.852-2.134-2.985-2.565-2.134-4.268-2.134-2.134-.851-1.7-4.478-.852-5.981-2.985-1.913-1.713,2.134-4.478,1.493-1.282,1.062-1.493.22-1.062-.22-.431,6.4-3.2h1.923l.21-1.282,5.76-2.555.641-.862h.852l28.8-3.406.21.852-.421.852.851,1.062,2.134-1.062,4.268,3.416.641,3.416,24.744-3.206,29.222,20.266-1.062.641-2.344,1.493-1.923,2.775-2.775,3.416-1.913,4.268-1.072,2.985v5.54l-.851.852-.641,1.282-1.923.22-1.062,1.272-1.493,1.713-1.493,2.344-1.072,1.923-3.626,2.555-2.134,3.206-1.913,1.7-2.565,1.913-1.7,1.713-1.282,1.062-2.134,1.072-1.282.421-.641.862.22.851-.431.421-1.062,2.134-1.713,1.713h-1.7l-.431.421-.21.431.431.641.852.21.421.431-.21,1.062-1.062.641-1.923,1.923-.641,1.493Z",
    transform: "translate(-857.22 -418.69)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "AL",
    transform: "translate(750.699 437.314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AL-2",
    "data-name": "AL"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2570",
    "data-name": "Path 2570",
    d: "M749.89,442.329l2.134,2.354-1.7,80.212.431,3.837,4.9,40.532,1.072-.852,1.272-.851,3.636,1.272.852-1.7.641-5.76,1.493-4.047,2.344,4.047-.21,1.493,1.062,3.206,2.565,3.616,2.344.22,1.913-.22,2.775-2.985.641-.21,1.282-1.062v-.641l-.431-.641-1.272-.641v-.641l1.062-2.555-.431-.852-1.7-1.5h-.641l-1.282-1.062-1.7-2.565-.21-1.913.641-.641-.21-.641V550.07l60.147-5.981-.421-1.7-2.775-4.268.431-7.042-2.775-5.971-.21-4.909,1.272-3.2v-3.626l2.134-2.985.21-.862-1.913-2.344.852-2.344-1.493-1.7-1.923-1.282-.852-1.713-1.282-4.047-1.493-1.493-16-57.392Z",
    transform: "translate(-749.89 -437.21)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "MS",
    transform: "translate(680.304 442.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MS-2",
    "data-name": "MS"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2571",
    "data-name": "Path 2571",
    d: "M750.015,442.32l-45.861,3.206-.21,1.493-4.268,3.837-1.493,4.057.421,4.478-.641,2.344-4.047,2.565-2.775,3.837-1.072,1.282v3.626l-1.913,2.344v2.775l-1.282,3.626-2.344,3.626,1.062,4.057,1.923,2.344.21,2.775.852.852v1.072l-1.282.842-.421,2.354v3.837l2.775,5.55.421,5.119,1.493,2.775,1.282,1.493.21,2.555-2.985,1.713-.641.852-1.493,5.76-4.268,6.612-3.626,11.52-.421,8.535,42.666-1.923,1.062,1.282-1.272,4.268v5.971l4.688,4.478,1.072,5.119,2.985.22L735.3,571.6l10.448-3.2,2.565.852,3.626-1.282.641,1.072,2.344.631.852-.421-4.9-40.532-.431-3.837,1.7-80.212Z",
    transform: "translate(-679.62 -442.32)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "AR",
    transform: "translate(607.775 404.255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AR-2",
    "data-name": "AR"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2572",
    "data-name": "Path 2572",
    d: "M607.22,408.468l96.851-4.258-.431,1.062,2.134,1.493.852,2.354-.431,2.134L703.21,413.6l-2.555,2.985-.21,1.913,14.716-1.062-.852,1.282.421,1.272-.852,2.354-2.775,2.985-1.062,5.54-2.775,3.626.421,3.847-.21,4.688-.852.431-2.344,2.134-.21,1.493-4.268,3.837-1.493,4.057.421,4.478-.641,2.344-4.047,2.565-2.775,3.837-1.072,1.282v3.626l-1.913,2.344v2.775L687,481.857l-2.344,3.626,1.062,4.057,1.923,2.344.21,2.775.852.852v1.072l-1.282.842L687,499.779v1.493L621.295,503.2V488.68l-3.416-.852-2.985,1.282-1.062-.21-3.416-2.565.641-47.995Z",
    transform: "translate(-607.22 -404.21)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LA",
    transform: "translate(621.851 501.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LA-2",
    "data-name": "LA"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2573",
    "data-name": "Path 2573",
    d: "M621.27,503.023l65.706-1.923v2.344l2.775,5.55.421,5.119,1.493,2.775,1.282,1.493.21,2.555-2.985,1.713-.641.852-1.493,5.76-4.268,6.612-3.626,11.52-.421,8.535L722.389,554l1.062,1.282-1.272,4.268v5.971L726.867,570l1.072,5.119-6.191-1.282-5.55-2.555-1.493-.21-1.493.852-4.047,3.626-.22,1.923,1.713,2.134,2.134.631,4.688-.421,2.565-1.713,1.7-.851h2.775l1.282-.21.21,1.062-.641,1.072-1.7,1.493.421,1.7,1.713.852,1.272.431,1.072-1.062,1.913-3.416,4.7-1.923,1.7-.851h1.072L738.6,577.9l-.641,1.923.641,1.062-.21,1.493-2.134,1.493-3.416,4.488-3.626,2.555-.21,2.565,1.282,1.913,4.688,2.775,8.114,3.2,1.062,1.5-.851,1.913-1.713.431-6.181,2.765-.641-5.109-3.626-1.713-7.043-2.775-.851-2.344-1.282-.851-1.913,1.062-1.072,4.909.641.641.21,1.072-3.626,2.555-1.493-.431-1.913-2.765-1.072-.21-2.344.851-1.072-1.072-1.062.22-3.2,3.406-3.626.21-1.282-.851-3.847-.852-5.76-7.042-3.2-.641-3.206-1.493-1.272-2.124h-.852l-.22-.431-.421-.431.421-1.272-1.493-.431-.852.431-2.555-.431-.641-.431-.431-1.7h-1.493l-4.478,4.047,2.134,2.354-.852.852-7.042.21-12.161-2.134-7.042-2.765-16,2.344-1.062-1.072-.431-1.7.641-.852.641-1.713,1.7-1.7,2.134-5.971-1.7-2.565v-1.913l.421-1.282-.21-1.713.641-3.406,1.7-1.282,1.072-2.565.852-4.9v-2.985l-.852-4.268-1.7-2.985-.862-.861.431-1.493-.852-1.062-1.282-2.565-1.493-1.282-.431-.852.852-2.985-1.913-3.837-3.2-2.985-1.072-1.713Z",
    transform: "translate(-621.27 -501.1)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "MO",
    transform: "translate(582.812 293.319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MO-2",
    "data-name": "MO"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2574",
    "data-name": "Path 2574",
    d: "M607.264,408.664l96.851-4.258-.431,1.062,2.134,1.493.852,2.354-.431,2.134-2.985,2.344-2.555,2.985-.21,1.913,14.716-1.062,1.062-4.057-.421-1.493,1.062-4.688,1.713-3.847,1.272-1.913,2.775-1.282,1.072.641,1.272-.851,2.134-6.832-.852-2.555-1.062-.851-.641-.431-.431-.421-.421-.641h-1.493l-.22,1.062-.852.431-4.268-7.473v-1.062l1.713-1.713v-1.062l-1.923-2.344-1.072-4.7-6.181-5.329-2.985-1.072-5.97-3.837-3.636-3.416-1.272-3.2.641-1.7,3.837-4.488-.431-3.837,1.072-3.416-.852-1.7-5.129-2.565-1.7.862-1.923,1.913-1.062-.852L686.4,329.1l-1.7-1.713-6.191-4.909-6.181-7.253-.431-1.913-1.493-4.478-.431-5.129,1.072-2.985v-1.062l-6.191-6.191L582.3,296.035l1.493,2.344,2.134,2.134.641,3.626,2.985,3.626,1.282.852-.641,2.775.431.852,8.956,6.832-2.775,3.406-.641,3.416,1.493,1.7,2.354,1.072,1.272,4.688,2.134,1.5,2.134.421.852.641.641,59.085Z",
    transform: "translate(-582.3 -293.47)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "IA",
    transform: "translate(565.531 213.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IA-2",
    "data-name": "IA"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2575",
    "data-name": "Path 2575",
    d: "M568.466,217.026l102.391-3.406,1.072,3.406,2.344,2.134v1.713l-1.7,2.555,1.062,3.416,1.923,7.463,6.191,2.134,1.913,1.7.852,2.565.852,1.493,4.057,2.775.431,2.565,4.047,2.344,1.282,4.688-.21,2.354-1.282,2.765-1.493,1.5v2.344l-3.626,3.837-3.206,1.062-1.062,1.072-4.057.21L678.12,271l-1.282,2.775.21,2.344,2.565,2.555.631,1.713-.631,4.047-3,6.622-3.2,2.134-1.062,2.134.21,2.134-1.493,2.344-6.191-6.191-82.556,2.565-.851-1.282-.641-2.985.641-2.134-1.493-2.134-.641-2.134,1.493-2.134-.852-2.134-2.775-1.493.641-4.268.852-2.344L577.853,271l-2.775-2.134-.851-2.344.851-2.134-2.344-2.134-1.282-4.478-2.134-1.923,1.282-3.837v-1.923l-2.985-1.7v-3.416l-.431-2.775-2.134-5.119,2.134-4.909-.431-2.344,1.5-1.282-.861-4.057-1.493-1.483,1.072-2.775-.852-1.493-.641-1.713,1.7-.21Z",
    transform: "translate(-565.05 -213.62)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "MN",
    transform: "translate(555.083 56.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MN-2",
    "data-name": "MN"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2576",
    "data-name": "Path 2576",
    d: "M568.485,217.3l-.21-49.7-6.832-6.622-.21-2.344,3.416-3.626,1.272-2.775-.21-2.344-.21-4.057.421-3.626-3.2-9.6-.21-2.134v-4.909l-.862-2.765-.421-13.654-1.493-7.894-2.354-2.565-1.7-8.745-.21-7.684.641-4.478.641-1.913-1.923-6.4-.21-2.134,36.905-.21.21-6.191.431-3.626h2.775l3.837,1.493.421,5.971,1.072,4.057-.21,3.626,4.047,2.985,1.493-.421,2.775.421,1.282,1.493,3.2-.431,3.416.641.852,1.282V79.5l5.339-.21,1.7-2.144,7.894-.421,5.119,1.493h1.272l-.841,1.493,1.7,1.493.852-.431.852.862.852,3.626,1.923,1.062,2.134-2.555,1.062-.641,2.134.641,1.282,2.555,4.268,1.072,1.282,1.7,1.913,1.493h2.775l2.775-.641,7.042-4.909,1.062.641,1.923,2.344,10.669-.21,1.7.431,1.282.852,2.775,1.923,2.344-1.072,4.688-.21-2.765,2.555-6.191,3.626-3.416.852-2.555,1.072-2.775,2.775-5.55,2.344-2.344,1.923-8.956,9.807-12.8,11.741-1.493,1.913-1.282,1.282.431,14.716-1.493,1.713-1.713.852-5.55,4.478-.21,2.344-.631.641-1.5,4.057,3,1.493,1.913,3.416-1.7,3.2.21,2.775-.421,4.478v7.253l1.062,1.493,2.134,1.493.421,1.282,5.129.852.852.641.21,1.282,1.282.852,5.971,2.565,1.923,4.258,5.329,4.057,6.191,4.268.852,1.493-.21,3.416.631,4.909Z",
    transform: "translate(-554.62 -57.31)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "WI",
    transform: "translate(636.567 119.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WI-2",
    "data-name": "WI"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2577",
    "data-name": "Path 2577",
    d: "M684.386,240.875l-.852-2.565-1.913-1.7-6.191-2.134-1.923-7.463-1.062-3.416,1.7-2.555v-1.713l-2.344-2.134-1.072-3.406-.631-4.909.21-3.416-.852-1.493-6.191-4.268-5.329-4.057-1.923-4.258-5.971-2.565-1.282-.852-.21-1.282-.852-.641-5.129-.852-.421-1.282-2.134-1.493-1.062-1.493v-7.253l.421-4.478-.21-2.775,1.7-3.2-1.913-3.416-3-1.493,1.5-4.057.631-.641.21-2.344,5.55-4.478,1.713-.852,1.493-1.713-.431-14.716,1.282-1.282,1.493-1.913,1.923,1.062,2.555.431,3.206-.22,5.119-2.985,9.6-4.909,1.7-.21.641,1.072V122.7l-.852,1.272v1.282l-1.062,3.837,3.626-1.7h1.913l2.344,2.134,2.134-.431,1.072,1.493,2.775.431,1.272,1.072.862,3.2,1.272.641,17.922,3.626h2.134l3.837,3.2h2.565l.851.852.852-.852h1.282l4.478.852,2.775.862,1.072,1.062-.431.641-.21.852,2.985.851,3.416,1.713.421,2.555-1.062,6.832.641.21,3.406-.641.431.431-.431,1.493-1.062,1.062.852,3.206,2.985,1.7-.421.431-4.057,4.047-2.565,5.119-.852,3.626-.421,1.713.852.631,2.985-1.483,3.2-5.981,3.416-2.775,1.713-.852.421-1.493,1.493-1.282.852-1.7-.21-1.913.21-1.5.861-.641.852-1.7.852-.852,1.062-.21.641,1.062-.421,3.416L746.9,170.9l-1.282,1.713-.641,2.555v1.493l-2.555,5.55v4.909l-.22,3.406-2.555,2.565-.641,1.7.851,3.847.21,6.612L739,206.744l-2.134,6.822,1.282,10.028,2.775,6.832-.641,1.062.421,1.493-.21,1.072.21,2.985Z",
    transform: "translate(-635.96 -119.49)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "VT",
    transform: "translate(1010.108 114.763)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VT-2",
    "data-name": "VT"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2578",
    "data-name": "Path 2578",
    d: "M1008.84,123.975l1.493,2.565-.641,1.282,1.072,1.272.21.862,2.985,7.894,1.062,5.75-1.272,2.775.21,2.985,3.416,7.684-.431,3.626.641,1.062.641-.21-.431-.852h1.282l2.134,3.416,1.282,6.612v3.837l1.493,4.488,2.134,4.478,14.716-3.206-.421-1.493-1.713-1.7.22-2.775.641-.852-.862-2.565-1.062-11.09V156.4l1.282-6.612,1.272-4.268.22-2.985-1.282-2.344V137.63l.852-1.493,4.267-3.626,2.344-5.971-2.344-3.416-.431-1.7.861-.852v-1.282l-1.072-4.057-34.772,8.745Z",
    transform: "translate(-1008.84 -115.23)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "NH",
    transform: "translate(1038.909 104.735)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NH-2",
    "data-name": "NH"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2579",
    "data-name": "Path 2579",
    d: "M1071.931,168.582l-1.282-.641-1.482.431-1.713,2.775-1.923.631.431,1.713-.431.641-.631-.641-.641.641-.22.852-23.251,5.329-.421-1.493-1.713-1.7.22-2.775.641-.852-.862-2.565-1.062-11.09v-3.416l1.282-6.612,1.272-4.268.22-2.985-1.282-2.344v-2.565l.852-1.493,4.267-3.626,2.344-5.971-2.344-3.416-.431-1.7.862-.852V119.3l-1.072-4.057.851-5.119-1.272-1.7.421-.641h1.493l.641-1.7,1.282.421,1.493-.21,1.062-1.072L1064.9,151.3l.21.852-.21,1.923.21.852,3.837,2.985.851.22.431,1.493v1.062l2.134,3.626-.431.641v3.626Z",
    transform: "translate(-1037.59 -105.22)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "DE",
    transform: "translate(995.171 270.709)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DE-2",
    "data-name": "DE"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2580",
    "data-name": "Path 2580",
    d: "M1017.612,305.882l-.431-2.555-1.493-3.837-2.555-2.565-3.847-2.565-1.272-1.7-.862-1.7-2.975-5.119L1002.9,283.7l-2.354-2.775L999.69,279l-.21-1.7.21-.21v-.862l1.282-4.909-1.7-.421-2.354.21L995,273.034l-.22,1.7-.631.431-.22.21,10.028,33.5Z",
    transform: "translate(-993.93 -270.9)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "DC",
    transform: "translate(971.419 300.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DC-2",
    "data-name": "DC"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2581",
    "data-name": "Path 2581",
    d: "M970.22,303.635l3.8-2.965,3.566,5.219-4.518,3.216Z",
    transform: "translate(-970.22 -300.67)",
    fill: "#eaeaea",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "GA",
    transform: "translate(807.87 430.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GA-2",
    "data-name": "GA"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2582",
    "data-name": "Path 2582",
    d: "M806.96,437.223l16,57.392,1.493,1.493,1.282,4.047.851,1.713,1.923,1.282,1.493,1.7-.852,2.344,1.913,2.344-.21.862-2.134,2.985v3.626l-1.272,3.2.21,4.909,2.775,5.971L830,538.131l2.775,4.268.421,1.7.22,1.282,2.134,2.134-.22,1.7,1.493,2.134,62.3-3.837.851,2.985.851,1.282,3.416.421.641-3.2-1.923-5.971.21-2.134.641-1.072,1.713-1.272L910,540.686l4.047.22,1.923-.641-.641-4.478-.852-2.354v-2.985l.431-2.344,3.2-9.387.641-4.057,1.493-3.837,1.923-3.837,1.913-1.923,1.072-.431.421-1.272-1.7-.431v-.641H922.8l-3.2-.21-.852-.641-.851-1.282-1.282-5.54-2.775-3.847-3.416-1.272-1.7-5.76-2.134-2.565-1.062-2.985-1.923-.852-3.837-1.493-2.354-2.985-2.555-1.713-.21-1.493-1.282-2.775-.852-.851-3.626-1.282-7.042-6.612-3.206-1.062-.852-2.134L874.8,452.37l-2.134-4.268-2.134-2.134-.851-1.7-4.478-.852-5.981-2.985-1.913-1.713,2.134-4.478,1.493-1.282L862,431.463l.22-1.062-.22-.431-32.848,4.7Z",
    transform: "translate(-806.96 -429.97)",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "NY",
    transform: "translate(901.957 123.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NY-2",
    "data-name": "NY"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2583",
    "data-name": "Path 2583",
    d: "M1006.687,227l17.7,6.181,1.282,2.985-1.282,1.282-.852,1.072-.431,1.7.22,2.985-1.282.22-.852.631-1.493,3.416v1.282l.421.21.852-.421.431-1.072,2.775-2.555,1.7.21h3.837l1.292-1.072,3.616-.852,3-1.493,2.134-1.062,2.344-2.354,9.807-6.612,2.564-1.7,2.134-1.7,1.7-.641,1.072-1.282,2.134-1.282,1.272-.851,1.072-2.344.211-.852-.421-.431-2.134,2.134-2.134.641-2.565,1.062-1.493,1.282-.852,1.713-2.344,1.062-.431-.641.851-1.7,1.7-1.923,1.923-3.2-.641-.641-1.7,1.7-1.072,1.713-1.493,1.493-5.54,2.985-7.042,3.626-5.76,2.775-2.134,1.062-2.134,2.985-1.282-.852-.421-2.134.851-2.565,1.913-1.493-2.124-2.134,3.2-3.406.22-1.5-1.5-1.7-2.554-20.045-.852-.641.21-18.773-2.134-4.478-1.493-4.488v-3.837l-1.282-6.612-2.134-3.416h-1.282l.431.852-.641.21-.641-1.062.431-3.626-3.416-7.684-.21-2.985,1.272-2.775-1.062-5.75-2.985-7.894-.21-.862-1.072-1.272.641-1.282-1.493-2.565h0l-25.605,6.4-.421-.852-1.062.431L980.02,131l-6.191,6.4-6.181,8.535-1.072,1.493.641,1.282-1.062,3.406-1.282,1.282-6.4,6.4-.641,1.282.852,2.555.641.431,1.7-.22,1.282.862.22,1.272-1.282,1.5.641,2.124,1.493,2.354-.431,3.837-4.047,1.7-5.981,6.4-4.478,1.493-10.238,2.985-3.416-1.272-3.2-.641-5.329.641-5.55,1.062-5.971,2.344-2.775,1.923-1.072,3.2v2.354l4.057,4.478.641.641.421,2.134-.631,1.7-1.5,1.072-1.493,3.837-8.315,8.535-3.2,2.344,1.483,7.042,87.465-17.5,1.493,1.072.641,1.493.641.641.641-.21.852.852,1.282.421,2.775,5.129.641,1.913.852.852.21.641,5.119.431Z",
    transform: "translate(-900.88 -123.96)",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#radial-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "FL",
    transform: "translate(773.529 538.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FL-2",
    "data-name": "FL"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2584",
    "data-name": "Path 2584",
    d: "M833.257,543.91l-60.146,5.981v1.062l.21.641-.641.641.21,1.913,1.7,2.565,1.282,1.062h.641l1.7,1.5.431.852-1.062,2.555v.641l1.272.641.431.641v.641l-1.282,1.062v1.713l.641.421,3.416-1.062,1.062-.862,1.282-3.2.431-1.062,1.493.421h1.282l.631-.421,1.072.21-.21.852-2.354,1.923.431.421,1.923-.851,2.765-.21,10.879-3.626h1.493v.852l-1.913,1.7.852.431,4.7.431,4.478,1.7,4.9,2.555,1.282.22-.21-1.493,1.062-.862,1.072,1.282,2.775.852.641.431.21.421-1.072.651.431.852,5.971,4.478.431,1.7-.21,1.493-.431,1.072-.852-.852-.431-1.072-.421,1.072.21,1.272L829,580.6l8.315-2.344.431-1.072,2.985-.21,6.822-5.55h4.488v-1.062l-.641-1.072,1.272-2.985,7.253-.852,10.889,5.55.21,1.493,2.775,2.134,2.344,3.626,6.822,4.9.861,1.923,1.913,1.713,5.119-.22,4.057,5.981,1.062.852-.421,1.7,1.7,5.971-.641,6.822-1.7,7.042.21,5.76.852,1.923,4.057,2.775,1.282-2.344-1.282-1.072-1.062-3.837.21-.641,2.344-.431,1.7,3.626H904.3l.421-1.913.641-.431,1.072.852-.21,1.713-1.072,1.913-1.062,1.713-1.5,4.478-1.272.641v2.134l1.493,1.7,2.344,2.134,3.626,8.1,5.76,3.626.641-.21.21-1.923h1.713l1.272,3.416.22,1.923,1.913,4.258,2.344,1.5,2.565.851,4.268,11.52,1.062.641,5.76,1.272,2.354,1.282,6.391,7.894,2.775,2.134H949.1l1.7.852.431,1.493-1.282.431-1.072-.431h-.631l-.861.431-.21,1.062.851,1.072,3.206.641,1.7-1.072,2.565-.21,9.387-3.626,2.124-3.837.22-.862-1.282-5.119.21-2.555,1.923-4.478,1.923.421-2.354-9.387.641-4.688-.421-8.745-1.923-7.042-1.282-2.565-6.612-8.525-4.047-9.607-5.129-6.822.22-.862-.431-1.7-1.7-3.626v-1.7l1.7-2.344v-1.072l-6.612-9.166-3.837-3.626-2.565-1.5-.641-1.272-4.268-5.76-5.76-10.238-1.483-5.981-3.636-8.315V550.1l-1.493-1.282-.851-.641-.641-5.971-.852-2.134-1.923.641-4.047-.22-4.478-2.124-1.713,1.272-.641,1.072-.21,2.134,1.923,5.971-.641,3.2-3.416-.421-.852-1.282-.851-2.985-62.3,3.837-1.493-2.134.22-1.7-2.134-2.134Z",
    transform: "translate(-772.68 -538.37)",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#radial-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TX",
    transform: "translate(332.368 403.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TX-2",
    "data-name": "TX"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2585",
    "data-name": "Path 2585",
    d: "M610.9,486.337l-1.062-.21-.861-1.072-1.913-.641-10.879-5.75-.641.641-3.206,1.062-4.9-.641h-1.923l-1.493.21-4.057,1.493-4.909.431-1.272.641-3.626,2.775-3.416-2.344-2.134-1.072v-.641l-.431-.421-1.7-.22-.852,1.282h-1.072L558,481.007l-.22-1.7-.851-.22-2.134,1.282-1.7,2.344.21,1.493-1.493,1.072-.852-1.713.431-2.344-.22-1.072h-1.913l-2.354,1.713h-.852l-5.329-4.057-1.7.641-.862,2.775-4.268-.852v-2.775l-.852-.421-2.555-2.134v-.852l-5.76-.862-1.493,1.713-2.354-1.072-1.493-2.134-1.7.431-.431.421h-1.272l-2.134-1.062-5.971-1.072-.641-.421-1.282-1.923.21-1.282-.641-1.272-2.555-1.282-1.493,1.282-4.488.421-1.493-.641-3.2-4.047-1.282-1.072-2.344-.421,1.7-52.693L425.3,403.35h-1.062l-9.817,122.878-81.7-7.674-.421.421.641.862.21.421-.852,1.7.852,2.134.421.431,4.268,2.775,1.072,2.775,1.7,3.837,4.267,2.775,12.592,15.147,10.659,8.535.851,1.493.641,1.913-.21,2.354.852,1.272,2.344,3.847-.21,8.745.641,2.555,3.837,6.191,16,11.731,10.879,6.822,3,.431,2.134-1.062,2.344-3,1.913-1.483,4.7-10.669,2.134-3.416,1.7-.852,3.847,1.062.852-.21.641-1.7,1.062-1.282,2.134.852,1.923,1.282,6.181.852,1.7.851,3.847,1.062,2.134-.852,4.909,2.775,1.062,2.775.851.431.431,1.062.852.21,2.134,1.282,2.775,3.837,4.688,4.057,2.354,3.626.21,1.7,7.042,16.86,1.062,3.416,7.684,8.746.641,2.124,5.329,5.76,1.493.861,2.134,2.555.641,1.493-.431,5.76,1.713,2.134.641,6.4,1.7,2.134,5.55,10.669.421,2.985,3.847.431L510,685.8l5.109,1.7,7.684,4.909,10.238.852,2.134.22,5.55,3.837,2.775,1.282,2.555-3.206,2.354.641.852-.852v-1.493l-2.354-.852.431-.852-2.344-2.775-3.416-12.8-1.7-5.119,2.555-7.684L542,661.056l-.641-.431-.641-.21-.431-.431v-.641l.431-.421,3.416-2.134,2.134-7.043-1.713-.641-.641-3.406,1.713-2.134,2.344,1.7,3.837-2.775,1.072-3.626-1.923-1.493.852-1.7.852.421,1.072.22.852-1.072,1.282.641h1.282l1.062-.431.21-.852v-2.985l.431-.852,1.062-.22.431.431,1.062.22,5.76-1.5.641-.21.22-1.062-.431-.641-2.985-1.713v-1.272l5.33-1.493.861-1.072,1.493-.431.421.431-.641.641.852,1.493h.862l1.062-.852,8.325-2.565,13.865-8.956.641-3.416,6.4-5.54.21-.851-2.775-3.847.641-2.985,4.268-1.7h.851l-.641,3.406.431,1.072,4.909-.641.852,1.282,9.807-4.268,5.76-.641.21-.21-.21-.641-1.062-1.072-.431-1.7.641-.852.641-1.713,1.7-1.7,2.134-5.971-1.7-2.565v-1.913l.421-1.282-.21-1.713.641-3.406,1.7-1.282,1.072-2.565.852-4.9v-2.985l-.852-4.268-1.7-2.985-.862-.861.431-1.493-.852-1.062-1.282-2.565-1.493-1.282-.431-.852.852-2.985-1.913-3.837-3.2-2.985-1.072-1.713-.641-27.3V488.681l-3.416-.852-2.985,1.282-1.062-.21Z",
    transform: "translate(-332.3 -403.35)",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#radial-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "AZ",
    transform: "translate(149.114 358.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AZ-2",
    "data-name": "AZ"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2586",
    "data-name": "Path 2586",
    d: "M275.022,529.512,296.781,375.7l-107.3-16.85h0l-2.565,14.075-4.047,11.52h-2.354l-1.7-1.7.21-.852-1.493-1.923-4.268-1.072-3.2.641L169,380.819l.841,5.119-1.272,13.013,1.062,1.923-1.7,5.76-1.062,1.913.21,1.282-.21,3.847.21,1.483-.21,1.072,1.7,3.416V422.2l.852,1.923.852,3.206,1.282.852,1.282,1.7.421,2.555-.421.862-.862-.641L169.215,435l-3.206,1.072-2.344,3.2-1.7,7.463-4.268,5.55h-2.344l-.22,1.493.641,1.923-.21,1.493-1.072,3.416.862,1.7,2.985,2.555.421,1.072-.852,1.282-.431,1.7-1.913,1.923-1.072-.22L151.083,470l-1.713,6.391,79.36,45.651,46.292,7.684Z",
    transform: "translate(-149.37 -358.85)",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#radial-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "NV",
    transform: "translate(77.437 197.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NV-2",
    "data-name": "NV"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2587",
    "data-name": "Path 2587",
    d: "M98.306,198.07,77.82,278.7l89.388,131.413-.21-1.282,1.062-1.913,1.7-5.76-1.062-1.923,1.272-13.013-.841-5.119,1.062-1.282,3.2-.641,4.268,1.072,1.493,1.923-.21.852,1.7,1.7H183l4.047-11.52,2.565-14.075L215.844,224.1l-59.3-12.372Z",
    transform: "translate(-77.82 -198.07)",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#radial-gradient-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CA",
    transform: "translate(0 175.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CA-2",
    "data-name": "CA"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2588",
    "data-name": "Path 2588",
    d: "M173.1,430.22l-1.272-1.713-1.282-.851-.852-3.206-.852-1.913v-2.555l-1.7-3.426.21-1.062-.21-1.493.21-3.837L77.957,278.752l20.476-80.643L17.37,175.93l-1.062,1.493-1.493,3.626,1.493,3.406-.641,7.473-1.923,3.2-1.7,1.493-.641,3.416v1.7l-7.684,8.535L.951,214.749l.21,2.775L.52,218.6l.431,3.416.852,2.555,1.282,1.272.631,1.5.22,1.493,2.555,5.76.641,5.76-.641,1.493-1.913,2.985L2.864,250.8l.431,2.134.641,2.565-1.7,2.775,3.2,8.315,1.7,3.626,4.268,4.7v9.807l-1.493,3,2.985,1.272,3.2,4.478,3,1.072.852-1.282v-1.493l2.344-2.354.641.22-.431,3.837.431,3,1.493,4.9-.21,2.565-.641.851-3.206-2.344-.421-1.072v-3.406l-.852-1.713-.862.431-.641,4.268-1.062.421.431,2.344-.641,1.282-.22,9.176,1.282,3.2,3.416,2.985,3.416,1.493,1.493,1.713-.431,4.478-2.344,2.555-1.282.431L20.355,332.3l-.421,6.832,4.7,6.812.421,2.575,1.282,2.555.421,3.206L33.368,366l2.565,2.134-.21,2.775h-.641l-.641.852.21,3,2.565,1.272.852,3.416-.641,1.282-.641,2.985-.852,4.688-1.493,1.933v2.124L37,394.807l4.047,2.765h3.2l9.817,4.488,3.416.841,3.416,2.565,2.344,5.981,3.837,3.416,3.2,1.272,5.339.641,1.923,2.134-.22,1.493.852,1.7-1.062,2.565,1.7,1.913,3.416-.21,5.119,4.7,2.354,4.047,2.555,2.565,4.478,9.6.21,8.745-.21.852.852,2.344h.431l.641.862-.431.21-.641,1.493.641,2.555.431.852,52.693,5.129,3.416.641,1.062.21,1.913-1.913.431-1.713.862-1.272-.431-1.082-2.985-2.555-.851-1.7,1.062-3.416.21-1.493-.641-1.913.22-1.493h2.344l4.268-5.55,1.7-7.473,2.344-3.2,3.206-1.062,2.765-2.344.852.631.431-.862Z",
    transform: "translate(-0.52 -175.93)",
    stroke: "#fff",
    strokeWidth: 1,
    fill: "url(#radial-gradient-7)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "PA",
    transform: "translate(888.302 211.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PA-2",
    "data-name": "PA"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2589",
    "data-name": "Path 2589",
    d: "M918.816,289.777l57.171-11.1,18.132-3.2.22-.21.631-.431.22-1.7,1.913-1.923,2.354-.21,1.7.421,5.329-3.626.641-2.985,3.416-3.406,3.2-1.923.22-.641-2.985-2.134-1.072-1.282-1.7-.631-.641-.862-2.134-.641-1.062-3.2-2.565-.431-.431-.421-.21-4.909,1.282-.852-.21-2.775-1.713-1.7v-.862l.431-.852,2.555-2.344.641-4.057v-1.272l1.493-2.344,1.072-.431L1005,225.353l-5.119-.431-.21-.641-.852-.852-.641-1.913-2.775-5.129-1.282-.421-.851-.852-.641.21-.641-.641-.641-1.493-1.493-1.072-87.465,17.5-1.483-7.042-4.7,4.478-.852.431-.641-.862h-.852L892.79,229.4l-3.837,3.416-1.7,1.072,6.391,35.833,4.057,24.1Z",
    transform: "translate(-887.25 -212.12)",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#radial-gradient-8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "MA",
    transform: "translate(1027.178 167.456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MA-2",
    "data-name": "MA"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2590",
    "data-name": "Path 2590",
    d: "M1026.09,183.408l14.716-3.206,23.251-5.329.22-.852.641-.641.631.641.431-.641-.431-1.713,1.923-.631,1.713-2.775,1.482-.431,1.282.641.851,3.2,2.775,2.134.641,1.282-.421.851-1.282.862-1.282,2.344-.851,2.985.21,1.493h2.775l2.565,1.493,4.258,4.268,1.5,2.775,1.913,2.344,4.909.21,2.775-1.282,1.7-3.2-.852-.641-1.923-1.923-2.555-1.062.21-1.282h2.775l3.2,4.7,1.923,4.688-.21,2.354-1.923-1.5-2.344,1.713-3.416,1.493-3.416,2.985H1085.4l-.641-.431v-1.272l-.641-2.354h-.641l-1.913,3.416-2.564,2.985-.641.852-1.493-1.7-.21-.852-.852-.21-.431-.641-1.492-.851v-.862l-3.627-.852-1.062-2.775-1.282-.421-.851-2.565-7.684,1.923-18.343,4.688-.22,1.072-.421.21-1.282-1.282-12.372,3-.851-.641Z",
    transform: "translate(-1025.88 -167.83)",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#radial-gradient-9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CT",
    transform: "translate(1028.029 194.765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CT-2",
    "data-name": "CT"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2591",
    "data-name": "Path 2591",
    d: "M1026.73,202.774l12.372-3,1.282,1.282.421-.21.22-1.072,18.343-4.688,4.478,15.147-.641,1.493-.421.852.211.641.21.641-2.344.421-6.191,2.565-1.7-.21-.641.641v1.062l-.641.21-3.627.641-5.119,2.354-.641-.862-2.985,3.416-7.042,5.971-2.775,1.493-2.124-2.134,3.2-3.406.22-1.5-1.5-1.7Z",
    transform: "translate(-1026.73 -195.09)",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#radial-gradient-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "NJ",
    transform: "translate(1000.932 226.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NJ-2",
    "data-name": "NJ"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2592",
    "data-name": "Path 2592",
    d: "M1000.962,271.4l-1.282,4.909v.862l.852-.431,1.282,2.344,1.7,2.134,1.5,1.7,4.9,2.565,1.493.431,3.416.631,1.282.22.21,3.2-.21,2.134,1.282,1.072,1.282-1.5,1.493-3.2.21-2.985,2.134-3.837,1.282-3.206.852-11.09,3.406,3.626,1.282-2.985v-2.134l-.641-8.956-.851-7.263-1.493-2.124-2.985.852-1.062.852-1.072-.431-.431-.421-.852.421-.421-.21V247.3l1.493-3.416.852-.631,1.282-.22-.22-2.985.431-1.7.851-1.072,1.282-1.282L1024.213,233l-17.7-6.181-1.072.431-1.493,2.344v1.272l-.641,4.057-2.555,2.344-.431.852v.862l1.713,1.7.21,2.775-1.282.852.21,4.909.431.421,2.565.431,1.062,3.2,2.134.641.641.862,1.7.631,1.072,1.282,2.985,2.134-.22.641-3.2,1.923-3.416,3.406-.641,2.985Z",
    transform: "translate(-999.68 -226.82)",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#radial-gradient-11)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsMap);
export default __webpack_public_path__ + "static/media/USMap.a5d8049d1f8403941166823ce35f5108.svg";
export { ForwardRef as ReactComponent };